import { render, staticRenderFns } from "./CytomineTags.vue?vue&type=template&id=36bde01e&scoped=true&"
import script from "./CytomineTags.vue?vue&type=script&lang=js&"
export * from "./CytomineTags.vue?vue&type=script&lang=js&"
import style0 from "./CytomineTags.vue?vue&type=style&index=0&id=36bde01e&scoped=true&lang=css&"
import style1 from "./CytomineTags.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bde01e",
  null
  
)

export default component.exports